import { ChainsInfo } from "./ChainsInfo"

export const RoutesData = {
    Home: "/rune/hello-chains",
    Construct: "/rune/hello-chains/construct",
    Start: "/rune/hello-chains/start",
    Address: "/rune/hello-chains/address",
    OrdinalsEvm: "/rune/ordinals/evm",

    // non-EVM chains
    Nervos: "/rune/hello-chains/nervos",
    StarkNet: "/rune/hello-chains/starknet",
}

const getChainInfo = (networkInfo: any) => {
    if(networkInfo.mainnet.contract.length === 0) return networkInfo.testnet;
    else return networkInfo.mainnet;
}

export const EvmRoutes = {
    ethereum: {
        route: "/rune/hello-chains/ethereum",
        ordinals: "/rune/ordinals/ethereum",
        title: "Ethereum",
        chainInfo: getChainInfo(ChainsInfo.ethereum)
    },
    arbNova: {
        route: "/rune/hello-chains/arbitrum-nova",
        ordinals: "/rune/ordinals/arbitrum-nova",
        title: "Arbitrum Nova",
        chainInfo: getChainInfo(ChainsInfo.arbNova)
    },
    base: {
        route: "/rune/hello-chains/base",
        ordinals: "/rune/ordinals/base",
        title: "Base",
        chainInfo: getChainInfo(ChainsInfo.base)
    },
    godwoken: {
        route: "/rune/hello-chains/godwoken",
        ordinals: "/rune/ordinals/godwoken",
        title: "Godwoken",
        chainInfo: getChainInfo(ChainsInfo.godwoken)
    },
    linea: {
        route: "/rune/hello-chains/linea",
        ordinals: "/rune/ordinals/linea",
        title: "Linea",
        chainInfo: getChainInfo(ChainsInfo.linea)
    },
    opBnb: {
        route: "/rune/hello-chains/opbnb",
        ordinals: "/rune/ordinals/opbnb",
        title: "opBNB",
        chainInfo: getChainInfo(ChainsInfo.opBnb)
    },
    pgn: {
        route: "/rune/hello-chains/pgn",
        ordinals: "/rune/ordinals/pgn",
        title: "PGN",
        chainInfo: getChainInfo(ChainsInfo.pgn)
    },
    polygon: {
        route: "/rune/hello-chains/polygon",
        ordinals: "/rune/ordinals/polygon",
        title: "Polygon",
        chainInfo: getChainInfo(ChainsInfo.polygon)
    },
    polygonZkEvm: {
        route: "/rune/hello-chains/polygon-zkevm",
        ordinals: "/rune/ordinals/polygon-zkevm",
        title: "Polygon zkEVM",
        chainInfo: getChainInfo(ChainsInfo.polygonZkEvm)
    },
    scroll: {
        route: "/rune/hello-chains/scroll",
        ordinals: "/rune/ordinals/scroll",
        title: "Scroll",
        chainInfo: getChainInfo(ChainsInfo.scroll)
    },
    taiko: {
        route: "/rune/hello-chains/taiko",
        ordinals: "/rune/ordinals/taiko",
        title: "Taiko",
        chainInfo: getChainInfo(ChainsInfo.taiko)
    },
    zksync: {
        route: "/rune/hello-chains/zksync",
        ordinals: "/rune/ordinals/zksync",
        title: "zkSync",
        chainInfo: getChainInfo(ChainsInfo.zksync)
    },
    zora: {
        route: "/rune/hello-chains/zora",
        ordinals: "/rune/ordinals/zora",
        title: "Zora",
        chainInfo: getChainInfo(ChainsInfo.zora)
    }
}
